<template>
  <div class="onlinePayment">
    <div v-if="tipShow" style="width: 100%;height: 100%;background: #000;opacity: .3;position: fixed;top: 0;left: 0;z-index: 10;"></div>
    <div v-if="tipShow" class="message">请在支付宝中打开此页面</div>
    <div class="top flex-center">
      <img src="@/image/xcx/top.png" alt="" style="width: 199px;">
    </div>
    <div class="data">
      <div class="flex-start" v-if="argDataShow">
        <!-- {{ argData }} -->
        <input type="text" v-model="input">
<!--        <div class="flex-center" @click="userIdto()">获取useId</div>-->
<!--        <bottom @click="toCode()">获取code</bottom>-->
      </div>
      <div class="tit flex-between">
        <div class="name" @click="moerCode">订单详情</div>
        <!-- <div class="name">订单详情</div> -->
        <div>{{ pageData.createTime }}</div>
      </div>
      <div class="box">
        <div class="li flex-between" v-for="item in list" :key="item">
          <div>{{item.name}}</div>
          <div v-if="item.arg=='plateNumber'" style="color: #FF5803;font-weight: bold;">{{pageData[item.arg]||''}}</div>
          <div v-else-if="pageData[item.arg]">{{pageData[item.arg]||''}}{{item.unit}}</div>
        </div>
      </div>
      <div class="box">
        <img v-show="pageData.orderPayStatus=='PAID'" src="https://cdn1.cheduoh.com/thirdEdition/global/group.png" alt="" class="yzfIcon">
        <div class="li flex-between" v-for="item in list2" :key="item" :style="item.sta&&pageData[item.arg]<1?'display: none':''">
          <div>{{item.name}}</div>
          <div v-if="item.sta" style="color: #FF5803">-￥{{pageData[item.arg] || 0}}</div>
          <div v-else>￥{{pageData[item.arg] || 0}}</div>
        </div>
        <div class="li flex-between" style="padding-top: 10px;border-top: 1px solid #E8E8E8;">
          <div></div>
          <div class="flex-start" style="align-items: flex-end">合计 ￥ <div style="font-size: 20px">{{ (pageData.showAmount*1000-pageData.integralAmount*1000-pageData.marketAmount*1000)/1000 }}</div></div>
        </div>
      </div>
    </div>
    <div v-if="pageSta&&pageData.orderPayStatus=='UNPAID'&&((pageData.showAmount*1000-pageData.integralAmount*1000-pageData.marketAmount*1000)/1000)>0" style="height: 110px;">
      <div class="base">
<!--        <div class="flex-start">-->
<!--          <img class="xzIcon" v-if="noticeSta" src="@/image/index9.png" alt="" @click="isOpen(false)">-->
<!--          <img class="xzIcon" v-else src="@/image/index8.png" alt="" @click="isOpen(true)">-->
<!--          <div class="flex-start">我已阅读并同意 <div style="color: #FB4714;" @click="show=true">《付款须知》</div></div>-->
<!--        </div>-->
        <div class="flex-between refer">
          <div class="flex-start" style="align-items: flex-end">￥<div style="font-size: 20px">{{ (pageData.showAmount*1000-pageData.integralAmount*1000-pageData.marketAmount*1000)/1000 }}</div>
            <div style="color: #999;margin-left: 10px;">抵扣金额￥{{(pageData.projectTotal*1000-(pageData.showAmount*1000-pageData.integralAmount*1000-pageData.marketAmount*1000))/1000}}</div>
          </div>
          <div class="btn flex-center" @click="submit()" v-if="((pageData.showAmount*1000-pageData.integralAmount*1000-pageData.marketAmount*1000)/1000)>0">确定订单</div>
          <div v-else>请去大兴小程序提交</div>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" :style="{'border-radius': '20px 20px 0 0'}">
      <div class="tkData">
        <div class="tit flex-center">付款须知</div>
        <div class="main">
          付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容付款须知内容
        </div>
        <div class="btn flex-center" @click="show=false">知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from '@/utils/request';
import {
  Toast,
  Popup
} from 'vant';

export default {
  name: "onlinePayment",
  components: {
    [Toast.name]: Toast,
    [Popup.name]: Popup,
  },
  data() {
    return {
      id: '', //2212-0004
      userId: '', // 2088902912874741
      list: [
        {name: '门店名称',arg: 'shopName'},
        {name: '工单号',arg: 'sn'},
        {name: '车牌号',arg: 'plateNumber'},
        {name: '公里数',arg: 'mileage',unit: 'km'},
        // {name: '项目',arg: 'project'},
        // {name: '材料',arg: 'materials'},
      ],
      list2: [
        // {name: '项目金额',arg: 'projectAmount'},
        // {name: '材料金额',arg: 'materialsAmount'},
        {name: '项目总价',arg: 'projectTotal'},
        // {name: '挂账',arg: 'debt',sta: true},
        {name: '预收款',arg: 'debtPay',sta: true},
        {name: '代金券',arg: 'coupon',sta: true},
        {name: '储值卡',arg: 'storageCardAmount',sta: true},
        {name: '超市余额',arg: 'marketAmount',sta: true},
        {name: '积分',arg: 'integralAmount',sta: true},
      ],
      pageData: '',
      noticeSta: true,
      show: false,
      pageSta: true,
      input: '',
      tipShow: false,
      argData: '',
      argDataShow: false,
    }
  },
  created:function(){
    // 从 URL 查询参数中获取 auth_code
    if (typeof AlipayJSBridge === 'undefined') {
      // 不在支付宝内，显示提示
      this.pageSta = false
      this.tipShow = true
    }else {
      this.handleGetAuthCode() 
    }
    this.id=this.$route.query.sn;
    this.getData(this.id);
  },
  methods: {
    handleGetAuthCode() {
      ap.getAuthCode(
          {
            appId: '2021006110661012',
            scopes: ['auth_base'],
          },
          (res) => {
            // ap.alert(JSON.stringify(res));
            if(res.authCode) {
              request({
                url: '/alipay/auth/handle_callback?auth_code='+res.authCode,
                method: 'GET',
              }).then(res=>{
                this.argData = res
                this.userId = res.data
              })
            }else{
              // Toast(res.errorMessage);
            }
          }
      );
    },
    getData(id) {
      let _this=this;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay:true
      });
      request({
        url: '/after_sale/activity/online_payment_order/detail?sn='+id,
        method: 'GET',
      }).then(res=>{
        Toast.clear();
        if(res.code=="200"){
          if(!this.pageSta) {
            Toast('请在支付宝中打开此页面');
          }
          // console.log(res)
          res.data.createTime = this.timestampToDateTime(res.data.createTime)
          _this.pageData=res.data;
        }else{
          Toast(res.msg);
        }
      });
    },
    timestampToDateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    isOpen(sta) {
      this.noticeSta = sta
    },
    moerCode() {
      // Toast(this.argData)
      this.argDataShow = true
    },
    submit() {
      let _this = this
      if(!_this.noticeSta) {
        Toast('请阅读并同意付款须知！');
        return
      }
      // Toast('(嘉联) 商户号不能为空 [BIZ_ERROR]');
      request({
        url: '/after_sale/activity/online_payment_order/confirm',
        method: 'POST',
        data: {
          id: _this.pageData.id,
          pageAmount: _this.pageData.showAmount,
        },
      }).then(res=>{
        res = res.data
        if(res.isException) {
          Toast(res.exceptionMsg)
          setTimeout(() => {
            _this.getData(_this.id);
          }, 2000);
        }else {
          _this.alipayCreate()
        }
      })
    },

    // 支付下单
    alipayCreate() {
      let data = {
        orderId: this.pageData.id,
        userId: this.userId || this.input,
      }
      // ap.alert(JSON.stringify(data));
      request({
        url: '/onlinePaymentOrder/ali_unified_pay',
        // url: '/api/jlpay/alipay/create',
        method: 'POST',
        data: data,
      }).then(res=>{
        // console.log(res)
        // ap.alert(JSON.stringify(res));
        if(res.code === '200') {
          if(res.data.channel==="WX_ALI_PAY"){
            this.submitAlipayForm(res.data.pay_info)
          }else{
            this.queryOrderJob()
            this.getLoad()
            AlipayJSBridge.call('tradePay', {
              tradeNO: res.data.pay_info
            }, function(res) {
              if (res.resultCode === '9000') {
                // alert('支付成功');
              } else {
                Toast('支付失败');
              }
            });
          }
        }else{
          Toast(res.msg);
        }
      })
    },
    submitAlipayForm(htmlContent) {
      const container = document.createElement('div')
      container.style.display = 'none'
      container.innerHTML = htmlContent
      document.body.appendChild(container)
      const form = container.querySelector('form')
      if (form) {
        form.submit()
      } else {
        Toast('支付表单解析失败')
      }
    },
    // 创建支付订单定时任务
    queryOrderJob() {
      request({
        url: '/api/jlpay/polling/query_order/job',
        method: 'POST',
        data: {
          orderId: this.pageData.id
        },
      }).then(res=>{})
    },
    getLoad() {
      let _this = this
      setTimeout(() => {
         request({
            url: '/after_sale/activity/online_payment_order/detail?sn='+_this.id,
            method: 'GET',
          }).then(res=>{
            if(res.code=="200"&&res.data.orderPayStatus=="PAID"){
              _this.getData(_this.id);
            }else{
              _this.getLoad()
            }
          })
      }, 1000);
    }
  }
}
</script>

<style>
body {
  background: #EEEFF4;
}

.flex-start {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.flex-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.flex-end {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.flex-between {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.onlinePayment {
  font-family: PingFang SC, PingFang SC;
}
.message {
  position: fixed;
  top: 30%;
  left: 15%;
  right: 15%;
  background-color: #333333; /* 可根据需要调整 */
  color: white;
  padding: 24px;
  border-radius: 6px;
  font-size: 14px;
  z-index: 9999;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.onlinePayment .title {
  height: 45px;
  background: #EDEDED;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

.top {
  text-align: center;
  background: linear-gradient(180deg, #FFE6DD 0%, #EEEFF4 100%);
  height: 365px;
  width: 100%;
}

.data {
  font-weight: 500;
  font-size: 13px;
  color: #666666;
  padding: 0 10px;
  margin-top: -64px;
}

.data .tit {
  height: 40px;
}

.data .tit .name {
  font-weight: bold;
  font-size: 15px;
  color: #333333;
}

.data .box {
  background: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 1px 10px 16px;
  position: relative;
}

.yzfIcon {
  position: absolute;
  bottom: 50px;
  right: 40px;
  width: 200px;
  height: 200px;
}
.data .box .li {
  margin-top: 20px;
}

.data .box .li > div:nth-child(2) {
  max-width: 200px;
  color: #333;
  word-break:break-all;
}

.base {
  font-weight: 500;
  font-size: 13px;
  color: #666666;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: #FFFFFF;
  padding: 10px 10px 20px;
}

.base .xzIcon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.base .btn {
  width: 188px;
  height: 36px;
  background: linear-gradient(180deg, #FF4F03 0%, #FE8400 100%);
  border-radius: 18px;
  font-weight: bold;
  font-size: 15px;
  color: #FFFFFF;
}

.base .refer {
  margin-top: 10px;
  font-weight: 500;
  font-size: 13px;
  color: #FB4714;
}

.tkData {
  padding: 0 10px;
}

.tkData .tit {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  padding: 12px 0;
}

.tkData .main {
  font-weight: 500;
  font-size: 13px;
  color: #666666;
  max-height: 300px;
  overflow: auto;
}

.tkData .btn {
  background: linear-gradient(180deg, #FF4F03 0%, #FE8400 100%);
  height: 36px;
  border-radius: 18px;
  font-weight: bold;
  font-size: 15px;
  color: #FFFFFF;
  margin: 30px 0;
}
</style>
